export type UserRole =
  | 'Admin'
  | 'Moderator'
  | 'Organizer'
  | 'VerifiedOrganizer';

export type UserStatus = 'New' | 'Verified';

export type EventStatus =
  | 'WaitingForReview'
  | 'WaitingForRefinement'
  | 'Approved'
  | 'Rejected'
  | 'Cancelled';

export type EventReportType =
  | 'Racism'
  | 'Violence'
  | 'SexualContent'
  | 'Spam'
  | 'Other';

export interface GetUserResult {
  id: string;
  firstName?: string;
  lastName?: string;
  nickname?: string;
  role?: UserRole;
  dateBannedTo?: null | Date;
  dateCreated?: Date;
  dateCreatedEvent?: null | Date;
  totalEvents: null| string;
  totalReported: null | string;
  totalReports: null | string;
}

export interface GetEventResult {
  id: string;
  name: string;
  description?: string;
  capacity?: number | null;
  cost?: number | null;
  startDate?: Date;
  endDate?: Date | null;
  lat?: number | null;
  lon?: number | null;
  address?: string | null;
  online?: boolean;
  pictureLink?: string | null;
  status?: EventStatus;
  moderatorComment?: string;
  creatorIsOrganizer?: boolean;
  organizer?: string | null;
  userCreatedId?: string;
  dateCreated?: Date;
}

export interface GetReportResult {
  id: string;
  type: EventReportType;
  description: string;
  processed: boolean;
  eventId: string;
  userCreatedId: string;
  dateCreated: Date;
}

export enum PodiyaAuthProvider {
  Apple = 'Apple',
  Facebook = 'Facebook'
}
